// Product brand and catalog data for HIG Automation.
// Edit this file to add or remove brands, products, descriptions and images.
// Header.jsx and Products.jsx will later import this data automatically.

export const productBrands = [
  {
    slug: "siemens",
    title: "Siemens",
    menuSummary: "PLC · HMI · Remote I/O · VFD",
    description:
      "Industrial automation and electrical control products for machines, production lines and plant systems.",
    products: [
      {
        slug: "simatic-plcs",
        title: "SIMATIC PLCs",
        subtitle: "Controllers for machine and plant automation",
        description:
          "Compact and modular controller families for machine control, production lines and scalable plant automation.",
        image:
          "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "simatic-hmi",
        title: "SIMATIC HMI",
        subtitle: "Operator panels and industrial visualization",
        description:
          "Industrial operator-interface products for machine operation, alarms, process visualization and diagnostics.",
        image:
          "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "remote-io",
        title: "Remote I/O",
        subtitle: "Distributed I/O for scalable control systems",
        description:
          "Modular distributed input and output systems for decentralized machine and plant architectures.",
        image:
          "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "sinamics-vfd",
        title: "SINAMICS VFD",
        subtitle: "Variable-frequency drives for industrial motors",
        description:
          "Drive products for controlled speed, torque and motor operation in conveyors, pumps, fans and machinery.",
        image:
          "https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "industrial-networking",
        title: "Industrial Networking",
        subtitle: "Communication and machine connectivity",
        description:
          "Industrial networking products for reliable communication between controllers, drives, I/O and field devices.",
        image:
          "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=700&q=80",
      },
    ],
  },
  {
    slug: "aignep",
    title: "Aignep",
    menuSummary: "Cylinders · Valves · Fittings · Tubing · Flow Control",
    description:
      "Pneumatic components and connection solutions for industrial machines, fixtures and automation systems.",
    products: [
      {
        slug: "air-cylinders",
        title: "Air Cylinders",
        subtitle: "Pneumatic actuators for machine motion",
        description:
          "Pneumatic cylinders for clamping, pushing, lifting, positioning and general industrial automation.",
        image:
          "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "solenoid-valves",
        title: "Solenoid Valves",
        subtitle: "Directional control for pneumatic systems",
        description:
          "Electrically operated valves for controlling pneumatic cylinders, grippers and automated equipment.",
        image:
          "https://images.unsplash.com/photo-1581092919535-7146ff1a590b?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "pneumatic-fittings",
        title: "Pneumatic Fittings",
        subtitle: "Push-in and threaded connections",
        description:
          "Compact pneumatic fittings for secure and maintainable compressed-air connections in machines.",
        image:
          "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "pneumatic-tubing",
        title: "Pneumatic Tubing",
        subtitle: "Flexible tubing for industrial air circuits",
        description:
          "Tubing products for pneumatic control circuits, machine-air distribution and automation assemblies.",
        image:
          "https://images.unsplash.com/photo-1620203853151-496c7228306c?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "flow-control",
        title: "Flow Control",
        subtitle: "Speed and airflow-control components",
        description:
          "Flow-control components for adjusting cylinder speed and tuning pneumatic system performance.",
        image:
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=700&q=80",
      },
    ],
  },
  {
    slug: "oriental-motor",
    title: "Oriental Motor",
    menuSummary: "AC Motors · Stepper Motors · Brushless Motors · Linear Motion",
    description:
      "Motion products for positioning, speed control, machine movement and compact industrial automation.",
    products: [
      {
        slug: "ac-motors",
        title: "AC Motors",
        subtitle: "Compact motors for continuous industrial motion",
        description:
          "AC motor solutions for constant-speed and controlled-motion applications in industrial equipment.",
        image:
          "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "stepper-motors",
        title: "Stepper Motors",
        subtitle: "Precise indexed motion and positioning",
        description:
          "Stepper motor systems for controlled positioning, indexing and repetitive machine movement.",
        image:
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "brushless-motors",
        title: "Brushless Motors",
        subtitle: "Efficient speed-controlled motor solutions",
        description:
          "Brushless motor and driver combinations for compact, efficient and adjustable-speed applications.",
        image:
          "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "servo-motors",
        title: "Servo Motors",
        subtitle: "High-response machine motion",
        description:
          "Servo motor solutions for high-response positioning and coordinated machine automation.",
        image:
          "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "linear-motion",
        title: "Linear Motion",
        subtitle: "Linear positioning and movement solutions",
        description:
          "Linear-motion products for controlled travel, positioning and automated handling applications.",
        image:
          "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=700&q=80",
      },
    ],
  },
  {
    slug: "iai-actuators",
    title: "IAI Actuators",
    menuSummary: "Electric Actuators · ROBO Cylinders · Cartesian Robots · Controllers",
    description:
      "Electric actuation and positioning products for flexible, clean and programmable machine automation.",
    products: [
      {
        slug: "electric-actuators",
        title: "Electric Actuators",
        subtitle: "Programmable linear machine motion",
        description:
          "Electric actuator solutions for repeatable positioning, flexible motion profiles and reduced air consumption.",
        image:
          "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "robo-cylinders",
        title: "ROBO Cylinders",
        subtitle: "Compact electric cylinders",
        description:
          "Compact programmable electric cylinders for positioning, pressing and controlled linear movement.",
        image:
          "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "cartesian-robots",
        title: "Cartesian Robots",
        subtitle: "Multi-axis positioning systems",
        description:
          "Cartesian robot systems for pick-and-place, dispensing, assembly and automated positioning.",
        image:
          "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "scara-robots",
        title: "SCARA Robots",
        subtitle: "High-speed handling and assembly",
        description:
          "SCARA robot products for fast assembly, component transfer and compact automation cells.",
        image:
          "https://images.unsplash.com/photo-1561557944-6e7860d1a7eb?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "actuator-controllers",
        title: "Actuator Controllers",
        subtitle: "Motion control for actuators and robots",
        description:
          "Controller products for operating electric actuators, multi-axis systems and robot mechanisms.",
        image:
          "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=700&q=80",
      },
    ],
  },
  {
    slug: "abb-robotics",
    title: "ABB Robotics",
    menuSummary: "Industrial Robots · Collaborative Robots · SCARA · Controllers",
    description:
      "Industrial robotic automation products for handling, assembly, machine tending and flexible production.",
    products: [
      {
        slug: "articulated-robots",
        title: "Articulated Robots",
        subtitle: "Flexible industrial automation robots",
        description:
          "Multi-axis industrial robots for handling, machine tending, welding and production automation.",
        image:
          "https://images.unsplash.com/photo-1561557944-6e7860d1a7eb?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "collaborative-robots",
        title: "Collaborative Robots",
        subtitle: "Cobots for flexible production tasks",
        description:
          "Collaborative robot solutions for applications requiring flexible deployment and close operator interaction.",
        image:
          "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "scara-robots",
        title: "SCARA Robots",
        subtitle: "High-speed assembly and handling",
        description:
          "SCARA robots for compact, high-speed assembly, sorting and component-handling applications.",
        image:
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "robot-controllers",
        title: "Robot Controllers",
        subtitle: "Control platforms for robotic cells",
        description:
          "Robot controller platforms for programming, coordinating and integrating industrial robotic systems.",
        image:
          "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=700&q=80",
      },
      {
        slug: "robot-accessories",
        title: "Robot Accessories",
        subtitle: "Integration products for robot systems",
        description:
          "Supporting products and integration accessories for complete industrial robot applications.",
        image:
          "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?auto=format&fit=crop&w=700&q=80",
      },
    ],
  },
];

// Compatibility exports for any existing components.
export const productCategories = productBrands.map((brand) => ({
  slug: brand.slug,
  title: brand.title,
  description: brand.description,
  subcategories: brand.products.map((product) => product.title),
}));

export const products = productBrands;

export const catalogProducts = productBrands.flatMap((brand) =>
  brand.products.map((product) => ({
    id: `${brand.slug}-${product.slug}`,
    category: brand.slug,
    subcategory: product.title,
    brand: brand.title,
    model: product.title,
    title: product.title,
    description: product.description,
    image: product.image,
  })),
);
